import { render, staticRenderFns } from "./lbRanking.vue?vue&type=template&id=58839ae1&scoped=true"
import script from "./lbRanking.vue?vue&type=script&lang=js"
export * from "./lbRanking.vue?vue&type=script&lang=js"
import style0 from "./lbRanking.vue?vue&type=style&index=0&id=58839ae1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58839ae1",
  null
  
)

export default component.exports